'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();

import { AppUiVisual } from '../app-ui-visual'
import { AI_CHAT, client, OVER_BUDGET } from '../demo-data'
import { useVisualCopy, type VisualCopy } from '../visual-copy'
import { AppHeader, AppScreen } from './app-screen'

type Exchange = { question: string; answer: string }

// Matches the design's static (non-animated) two-exchange AI-strook content for the time-tracking
// page: hours totals per client, then which clients are over budget — distinct from the shared
// `AiChatVisual` (jaarrekeningen/planning content, reused on the home and planning pages).
const exchanges = (t: VisualCopy): Exchange[] => [
  {
    question: t.chat.hours.question,
    answer: t.chat.hours.lastMonth(
      AI_CHAT.hours.lastMonthHours,
      t.monthsShort[5],
      AI_CHAT.hours.lastMonthBillable,
      t.monthActivity.administratie.fullLabel,
    ),
  },
  {
    // The two clients over budget, and their percentages, are exactly the two `BudgetVisual` flags.
    question: t.chat.hours.followUp,
    answer: t.chat.hours.overBudget(
      OVER_BUDGET.length,
      OVER_BUDGET.map((row) => `${client(row.nr).short} (${row.overrunPct}%)`).join(t.chat.and),
    ),
  },
]

/** Small sparkle icon, accent stroke, inside a 24px accent-soft rounded square. */
function SparkleIcon() {
  return (
    <span
      className="flex size-[24px] shrink-0 items-center justify-center rounded-[7px]"
      style={{ background: 'var(--au-accent-soft)' }}
    >
      <svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden>
        <path
          d="M8 1L9.4 6.6L15 8L9.4 9.4L8 15L6.6 9.4L1 8L6.6 6.6L8 1Z"
          stroke="var(--au-accent)"
          strokeWidth="1.1"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

/** Right-arrow send icon for the input bar's accent send button. */
function SendIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M3 8H13M13 8L9 4M13 8L9 12"
        stroke="#ffffff"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

/**
 * Modules card — AI assistant chat window (MCP), scoped to hours/budget questions: "how many hours
 * did the team book on this client last month" and "which clients are over budget", each answered
 * inline. Rendered as a static resolved exchange (mirroring the design's own static markup for this
 * strip, unlike the looping `AiChatVisual`) so it needs no client-side scenario driver.
 */
export function HoursAiChatVisual({ className }: { className?: string }) {
  const { t } = useVisualCopy()
  return (
    <AppUiVisual label="AI-assistent via MCP" className={className}>
      <AppScreen>
        <div className="flex h-full flex-col">
          <AppHeader
            leading={<SparkleIcon />}
            title="AI-assistent"
            right={
              <span
                className="rounded-[5px] px-1.5 py-0.5 text-[9px] font-bold whitespace-nowrap"
                style={{ background: 'var(--au-accent-soft)', color: 'var(--au-accent)' }}
              >
                MCP
              </span>
            }
          />

          <div className="flex flex-1 flex-col justify-center gap-2.5 overflow-hidden px-4 py-3.5">
            {exchanges(t).map((exchange) => (
              <div key={exchange.question} className="flex flex-col gap-1.5">
                <div className="flex justify-end">
                  <div
                    className="max-w-[85%] px-2.5 py-1.5 text-[10.5px] leading-snug font-medium text-white"
                    style={{ background: 'var(--au-accent)', borderRadius: '13px 13px 4px 13px' }}
                  >
                    {exchange.question}
                  </div>
                </div>
                <div className="flex justify-start">
                  <div
                    className="max-w-[92%] px-2.5 py-1.5 text-[10.5px] leading-snug"
                    style={{
                      background: 'var(--au-field)',
                      borderRadius: '13px 13px 13px 4px',
                      color: 'var(--au-text)',
                    }}
                  >
                    {exchange.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center gap-2 border-t px-3 py-2.5" style={{ borderColor: 'var(--au-hairline)' }}>
            <div
              className="min-w-0 flex-1 truncate rounded-[9px] px-2.5 py-2 text-[9px]"
              style={{ background: 'var(--au-field)', color: 'var(--au-text2)' }}
            >
              {t.screen.aiChat.askHours}
            </div>
            <span
              className="flex size-[30px] shrink-0 items-center justify-center rounded-[8px]"
              style={{ background: 'var(--au-accent)' }}
            >
              <SendIcon />
            </span>
          </div>
        </div>
      </AppScreen>
    </AppUiVisual>
  )
}
